import mapbox from 'mapbox-gl';

import { UNIVERSAL_ENV_VARS } from '@config/environmentVariables';

mapbox.accessToken = UNIVERSAL_ENV_VARS.MAPBOX_TOKEN;

export default mapbox;
